import axios from 'axios'
import { environment } from '../../../data/environment'
import { saveAs } from 'file-saver'
import { refreshToken } from '@/auth/refreshJwt'

export default {
  namespaced: true,
  state: {
    error: null,
    listTransactions: [],
    statusResponse: null,
    statusResponseMsg: '',
  },
  mutations: {
    setListTransactions (state, data) {
      state.listTransactions = data
      state.error = null
    },
    setStatusResponseDownloadCaptureFile (state, data) {
      state.statusResponse = data
    },
    setStatusResponseDownloadCaptureFileMsg (state, data) {
      state.statusResponseMsg = data
    },
  },
  actions: {
    getListTransactions ({ commit }, data) {
      let params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania

      if (!data) {
        let currentDate = new Date()
        currentDate = currentDate.getFullYear() + '-' + String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + String(currentDate.getDate()).padStart(2, '0')
        params += `&FechaInicial= ${currentDate}`
        params += `&FechaFinal= ${currentDate}`
      } else {
        if (data.NumeroAutorizacion) {
          params += `&NumeroAutorizacion= ${data.NumeroAutorizacion}`
        }
        if (data.IdTransaccion) {
          params += `&IdTransaccionHioPos= ${data.IdTransaccion}`
        }
        if (data.TipoTransaccion) {
          params += `&TipoTransaccion= ${data.TipoTransaccion}`
        }
        if (data.TipoTef && data.TipoTef !== '999') {
          params += `&TipoTef= ${data.TipoTef}`
        }
        if (data.Estatus) {
          params += `&Estatus= ${data.Estatus}`
        }
        if (data.dates) {
          params += `&FechaInicial= ${data.dates[0]}`
          params += `&FechaFinal= ${data.dates[1]}`
        }
      }
      const endpoint = '/transactions?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      })
        .get(url)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })

              return newAxiosInstance.get(url)
            })
              .then(response => {
                if (!response.data.Error) {
                  commit('setListTransactions', response.data.Datos)
                }
              })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            if (!response.data.Error) {
              commit('setListTransactions', response.data.Datos)
              return
            }
            console.log('Error /transactions', response.data)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    downloadCaptureFile ({ commit }, data) {
      let params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      if (!data.dates) {
        const currentDate = new Date()

        const previousDate = new Date(currentDate)
        previousDate.setDate(currentDate.getDate() - 1)

        const formatDate = (date) => {
          return date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0')
        }

        const formattedPreviousDate = formatDate(previousDate)

        params += `&FechaInicial=${formattedPreviousDate}`
        params += `&FechaFinal=${formattedPreviousDate}`
      } else {
        if (data.NumeroAutorizacion) {
          params += `&NumeroAutorizacion= ${data.NumeroAutorizacion}`
        }
        if (data.IdTransaccion) {
          params += `&IdTransaccionHioPos= ${data.IdTransaccion}`
        }
        if (data.TipoTransaccion) {
          params += `&TipoTransaccion= ${data.TipoTransaccion}`
        }
        if (data.TipoTef && data.TipoTef !== '999') {
          params += `&TipoTef= ${data.TipoTef}`
        }
        if (data.Estatus) {
          params += `&Estatus= ${data.Estatus}`
        }
        if (data.dates) {
          params += `&FechaInicial= ${data.dates[0]}`
          params += `&FechaFinal= ${data.dates[1]}`
        }
      }

      const endpoint = '/generateCaptureFile?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      const now = new Date()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const year = now.getFullYear()

      axios
        .create(
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(atob(localStorage.getItem('uid'))).jwt}`,
            },
          },
        )
        .get(url, { responseType: 'blob' })
        .then(response => {
            if (response.data.respuesta?.Mensaje === 'token_invalid') {
              refreshToken().then(() => {
                const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
                const newAxiosInstance = axios.create({
                  headers: {
                    Authorization: `Bearer ${newJwt}`,
                  },
                })

                return newAxiosInstance.get(url)
              })
                .then(response => {
                  response.data.text().then(text => {
                    try {
                      const json = JSON.parse(text)

                      if (json.Error === true) {
                        commit('setStatusResponseDownloadCaptureFileMsg', json.Mensaje)
                        commit('setStatusResponseDownloadCaptureFile', false)
                      } else {
                        const blob = new Blob([text], { type: 'text/plain' })
                        saveAs(blob, `${year}${month}${day}.adn`)
                      }
                    } catch (error) {
                      const blob = new Blob([text], { type: 'text/plain' })
                      saveAs(blob, `${year}${month}${day}.adn`)
                    }
                  }).catch(error => {
                    console.error('Error leyendo el Blob:', error.message)
                    commit('setStatusResponseDownloadCaptureFileMsg', 'Error al leer la respuesta')
                    commit('setStatusResponseDownloadCaptureFile', false)
                  })
                })
                .catch(function (error) {
                  console.error('Error descargando el archivo:', error.message)
                  commit('setStatusResponseDownloadCaptureFileMsg', 'Error en la descarga')
                  commit('setStatusResponseDownloadCaptureFile', false)
                })
            } else {
              response.data.text().then(text => {
                try {
                  const json = JSON.parse(text)

                  if (json.Error === true) {
                    commit('setStatusResponseDownloadCaptureFileMsg', json.Mensaje)
                    commit('setStatusResponseDownloadCaptureFile', false)
                  } else {
                    const blob = new Blob([text], { type: 'text/plain' })
                    saveAs(blob, `${year}${month}${day}.adn`)
                  }
                } catch (error) {
                  const blob = new Blob([text], { type: 'text/plain' })
                  saveAs(blob, `${year}${month}${day}.adn`)
                }
              }).catch(error => {
                console.error('Error leyendo el Blob:', error.message)
                commit('setStatusResponseDownloadCaptureFileMsg', 'Error al leer la respuesta')
                commit('setStatusResponseDownloadCaptureFile', false)
              })
            }
        })
        .catch(error => {
          console.error('Error descargando el archivo:', error.message)
          commit('setStatusResponseDownloadCaptureFileMsg', 'Error en la descarga')
          commit('setStatusResponseDownloadCaptureFile', false)
        })
    },
    setStatusResponseDownloadCaptureFile ({ commit }, data) {
      commit('setStatusResponseDownloadCaptureFile', data)
    },
  },
}
